import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Collapse,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useInstrumentation } from "../../InstrumentationContext";

const fieldGroups = [
  {
    label: null,
    fields: [
      { name: "Spec", label: "Spec", size: 3 },
      { name: "Flange Rating", label: "Flange Rating", size: 3 },
      { name: "CA", label: "CA", size: 3 },
      { name: "Service", label: "Service", size: 3 },
    ],
  },
  {
    label: "Temp. / Pressure Rating",
    fields: [
      { name: "Min", label: "Min", size: 3 },
      { name: "Max", label: "Max", size: 9 },
    ],
  },
  {
    label: null,
    fields: [
      { name: "VT", label: "VT", size: 3 },
      { name: "RT", label: "RT", size: 3 },
      { name: "PWHT", label: "PWHT", size: 3 },
      { name: "WPS", label: "WPS", size: 3 },
    ],
  },
];

export function SpecInputs({ selectIndex }) {
  const [open, setOpen] = useState(false);
  const { selectedSpecs, setSelectedSpecs } = useInstrumentation();
  const changeTimer = useRef(null);

  const initialValues = Object.fromEntries(
    fieldGroups.flatMap((group) => group.fields.map((f) => [f.name, ""]))
  );

  const selectedData = selectedSpecs?.[selectIndex] || {};
  const [formData, setFormData] = useState({
    ...initialValues,
    ...selectedData,
  });

  function saveAfterDelay() {
    if (changeTimer.current) {
      clearTimeout(changeTimer.current);
    }

    changeTimer.current = setTimeout(() => {
      setSelectedSpecs((prev) =>
        prev.map((spec, index) =>
          index === selectIndex ? { ...spec, specInfo: { ...formData } } : spec
        )
      );
    }, 500);
  }

  function handleChange(field, value) {
    setFormData((prev) => ({ ...prev, [field]: value }));
    saveAfterDelay();
  }

  const disabled = !selectedSpecs[selectIndex];

  return (
    <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
      <Button variant="contained" onClick={() => setOpen((o) => !o)}>
        {open ? "Hide SPEC Information" : "Show SPEC Information"}
      </Button>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            SPEC Information
          </Typography>

          <Grid container spacing={2}>
            {fieldGroups.map((group, index) => (
              <React.Fragment key={index}>
                {group.label && (
                  <Grid item xs={12}>
                    <Typography variant="body2">{group.label}</Typography>
                  </Grid>
                )}

                {group.fields.map((field) => (
                  <Grid item xs={12} sm={field.size} key={field.name}>
                    <TextField
                      fullWidth
                      label={field.label}
                      value={formData[field.name]}
                      onChange={(e) => handleChange(field.name, e.target.value)}
                      disabled={disabled}
                    />
                  </Grid>
                ))}
              </React.Fragment>
            ))}
          </Grid>
        </Box>
      </Collapse>
    </Box>
  );
}
